import { Modal, Stack, Select, TextInput, Group, Button } from "@mantine/core";
import { useForm } from "@mantine/form";
import { userActions } from "../store/userActions";

export default function AbsenceModal({ opened, onClose, household = [], defaultResidentId }) {
  const form = useForm({
    initialValues: {
      resident_id: defaultResidentId ? String(defaultResidentId) : "",
      type: "vacation",
      log_date: new Date().toISOString().split("T")[0],
    },
    validate: {
      resident_id: (value) => (!value ? "Vui lòng chọn thành viên" : null),
    },
  });

  const memberOptions = household.map((member) => ({
    value: String(member.id),
    label: member.name,
  }));

  const handleSubmit = (values) => {
    userActions.logAbsence({
      resident_id: values.resident_id,
      type: values.type,
      log_date: values.log_date,
    });
    form.reset();
    onClose();
  };

  return (
    <Modal opened={opened} onClose={onClose} title="Báo vắng mặt tạm thời" centered size="sm">
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack gap="sm">
          <Select
            required
            label="Chọn thành viên"
            placeholder="Chọn người vắng mặt"
            data={memberOptions}
            {...form.getInputProps("resident_id")}
          />
          <Select
            label="Lý do"
            data={[
              { value: "vacation", label: "Nghỉ phép / Du lịch" },
              { value: "business", label: "Công tác" },
              { value: "hospital", label: "Y tế / Bệnh viện" },
              { value: "moved_out", label: "Đã chuyển đi" },
            ]}
            {...form.getInputProps("type")}
          />
          <TextInput type="date" label="Ngày bắt đầu" {...form.getInputProps("log_date")} />
          <Group justify="flex-end" mt="md">
            <Button variant="light" color="gray" onClick={onClose} size="xs">Hủy</Button>
            <Button type="submit" size="xs">Xác nhận</Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
}
